import { API } from './api';

/**
 * Exchange a Google ID token for your backend JWT + user object.
 *
 * @param {string} idToken 
 * @returns {Promise<{ }>}
 */
export async function loginWithGoogleIdToken(idToken) {
  if (!idToken) {
    throw new Error('Missing Google ID token');
  }

  const res = await API.post('/auth/google', { idToken });
  return res.data;
}
